import { render, staticRenderFns } from "./StandardReview.vue?vue&type=template&id=c86c5490&scoped=true&"
import script from "./StandardReview.vue?vue&type=script&lang=js&"
export * from "./StandardReview.vue?vue&type=script&lang=js&"
import style0 from "./StandardReview.vue?vue&type=style&index=0&id=c86c5490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86c5490",
  null
  
)

export default component.exports